import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        tenderContent: null, // 招标内容
        tenderContentNum: null, // 招标内容编码
        tenderClassNum: null, // 招标类别编号
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "招标内容：",
          value: "tenderContent",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "招标内容编码：",
          value: "tenderContentNum",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "招标类别：",
          value: "tenderClassNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201510200918460003"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标内容",
          prop: "tenderContent",
          isShow: true,
        },
        {
          label: "招标内容编码",
          prop: "tenderContentNum",
        },
        {
          label: "招标类别",
          prop: "tenderClassName",
        },
        {
          label: "直接发包备案项目内容标志",
          prop: "flagName",
        },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/tenderContent/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[1] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 子传父
      // 子传父
      this.$router.push({path: "/tenderContentDetail", query: {id:e.val.id,type: "details" }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 子传父
      this.$router.push({path: "/tenderContentDetail", query: {type: "insert" }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 子传父
          this.$router.push({path: "/tenderContentDetail", query: {id:this.multipleSelection[0].id,type: "update" }});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/tenderContent/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { result,msg } = res.data;
            // 判断
            if(result){
              // 操作成功
              this.$message.success(msg);
              // 获取一览表格数据
              this.fun_GetList();
            }else{
              // 提示请求失败消息
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
